module.exports = __webpack_public_path__ + "img/unionpay.7a15e0f6.svg";